import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="25" y="15" rx="5" ry="5" width="110" height="10" />
      <rect x="25" y="45" rx="5" ry="5" width="230" height="10" />
      <rect x="25" y="98" rx="5" ry="5" width="35" height="30" />
      <rect x="80" y="100" rx="5" ry="5" width="60" height="7" />
      <rect x="80" y="115" rx="5" ry="5" width="200" height="7" />

      <rect x="25" y="140" rx="5" ry="5" width="35" height="30" />
      <rect x="80" y="142" rx="5" ry="5" width="60" height="7" />
      <rect x="80" y="157" rx="5" ry="5" width="200" height="7" />

      <rect x="25" y="182" rx="5" ry="5" width="35" height="30" />
      <rect x="80" y="186" rx="5" ry="5" width="60" height="7" />
      <rect x="80" y="200" rx="5" ry="5" width="200" height="7" />
    </React.Fragment>
  );
};
